/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FilmrollAutoAddIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Filmroll Auto Add',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32 26v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
    />
    <rect height="22" rx="1" ry="1" width="14" y="8" />
    <path
      d="M20 24a5.015 5.015 0 0 1 5-5h1a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H16v18h2a2 2 0 0 0 2-2ZM10 6V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2Z"
    />
  </svg>`;
};
